import React from 'react'

export const IconGridSizeMaximised = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <rect x="3" y="2" width="8" height="20" rx="2" fill="currentColor" />
    <rect x="13" y="2" width="8" height="20" rx="2" fill="currentColor" />
  </svg>
)
